import React from 'react'
import { useDispatch } from 'react-redux'
import { CheckboxInterface } from 'common/types/entities/CheckboxInterface'
import { toggleExplicitConsent } from 'publisher/actionsManagement'
import { usePopupOpenerRef } from 'publisher/hooks/use-popup-opener-ref'
import { managementSelectors, useManagement } from 'publisher/store'
import { BasePublisherCheckbox } from 'src/publisher/entities/base-publisher-checkbox'

interface CheckboxProps {
  entity: CheckboxInterface
}

const Checkbox = ({ entity }: CheckboxProps) => {
  const ref = usePopupOpenerRef()
  const dispatch = useDispatch()

  const toggleConfirmed = () => dispatch(toggleExplicitConsent(entity.id))
  const isConfirmed = useManagement(m =>
    managementSelectors.getConfirmedCheckboxesIds(m).includes(entity.id),
  )

  return (
    <BasePublisherCheckbox
      ref={ref}
      entity={entity}
      checked={isConfirmed}
      onChange={toggleConfirmed}
    />
  )
}

export default Checkbox
